module.exports = __webpack_public_path__ + "Flaticon.01008d8ad4353e801a37.eot";


//////////////////
// WEBPACK FOOTER
// /Users/alexandre/Documents/web/riberfuso/resources/ng/src/assets/fonts/header/Flaticon.eot
// module id = ../../../../../src/assets/fonts/header/Flaticon.eot
// module chunks = 6